export default __webpack_public_path__ + "static/Landmark-Inline-4cd964672ebffab12790296cad1b4daf.woff2";